import { Store } from 'vuex';

export function trackSportOfferExperiments(store: Store<unknown>): Promise<void> {
    return store.dispatch('ui/sportOffer/experiments/trackSportOfferExperiments', null, { root: true });
}
